import React from "react";
import "./OnlineBenefits.css";
import check from "../assets/check.svg";
const benefits = [
  {
    icon: check, 
    title: "24/7 Availability:",
    description: "Shop anytime, anywhere across Pakistan",
  },
  {
    icon: check,
    title: "Detailed Product Information:",
    description:
      "Complete specifications, coverage details, and application guidelines",
  },
  {
    icon: check,
    title: "Customer Reviews:",
    description: "Read authentic reviews from verified customers",
  },
  {
    icon: check,
    title: "Technical Support:",
    description: "Access to paint application guides and expert advice",
  },
  {
    icon: check,
    title: "Bulk Order Discounts:",
    description: "Special pricing for contractors and large projects",
  },
];

const OnlineBenefits = () => {
  return (
    <section className="benefits-section">
      <h2 className="benefits-title">Online Shopping Benefits</h2>
      <p className="benefits-subtitle">
        Based on customer feedback, here's why families and professionals across
        Pakistan prefer Glamur Paints:
      </p>

      <div className="benefits-grid">
        {benefits.map((item, index) => (
          <div key={index} className="benefit-card">
            <img src={item.icon} alt="" className="benefit-icon" />
            <h3 className="benefit-title">{item.title}</h3>
            <p className="benefit-desc">{item.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default OnlineBenefits;
